import React from "react";

interface FactoidProps {
    text: string;
}

export const Factoid = ({text}: FactoidProps) => {
    return (
        <div>
            <p className={'factoid'}>{text}</p>
        </div>
    );
};
